import React from 'react';
import SubfolderCard from './SubfolderCard';
import SubfolderCardContainer, { OwnProps } from './SubfolderCard.container';

export default SubfolderCardContainer(SubfolderCard) as React.ComponentType<
  OwnProps
>;
